import React from "react";
import Loader from "./loader";

export default function SubmitButton({ isSubmitting }) {
  if (isSubmitting) {
    return (
      <div className="comment-submit">
        <button disabled>Submit</button>
        <Loader />
      </div>
    );
  } else {
    return (
      <div className="comment-submit">
        <button>Submit</button>
      </div>
    );
  }
}